//= Structures & Data
// Own
import { ThemeContextData } from './ThemeContextData';

export const DefaultTheme: ThemeContextData = {
    buttonTheme: 'px-4 py-2 rounded-lg text-sm font-medium cursor-pointer transition-colors bg-accent hover:bg-accent-hover text-white',
    simpleCardTheme: 'p-4 rounded-xl bg-panel border border-white/[0.06]',
    tabsMenuTheme: 'flex gap-1 p-1 rounded-xl',
    tabsVerticalMenuTheme: 'flex flex-col gap-1',
    tabsMenuItemTheme: 'px-3 py-2 text-sm rounded-lg transition-colors cursor-pointer',
    tabsContextTheme: 'p-3 mt-2',
    statisticTheme: 'flex flex-col gap-0.5',
    statisticLabelTheme: 'text-xs text-unselected1 uppercase tracking-wide font-medium',
    statisticContentTheme: 'text-title font-semibold',
};
